export const LogoMark = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect width="48" height="48" rx="10" fill="#181715" />
    <path d="M11 33.5 L24 21 L37 33.5" stroke="#C87D32" strokeWidth="3" strokeLinecap="square" />
    <path d="M11 23 L24 10.5 L37 23" stroke="#E9C093" strokeWidth="3" strokeLinecap="square" />
    <path d="M11 40.5 L24 28.5 L37 40.5" stroke="#605D56" strokeWidth="3" strokeLinecap="square" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark size={compact ? 34 : 40} />
    <div className="leading-none">
      <span className="block font-serif text-lg tracking-[0.18em] font-semibold text-foreground">
        COC
      </span>
      <span className="block font-mono text-[9px] tracking-[0.3em] uppercase text-muted-foreground mt-1">
        Flooring Ltd
      </span>
    </div>
  </div>
);
